import React from 'react';
import PropTypes from 'prop-types';

import InlineWrapper from '../wrappers/InlineWrapper';
import TimePicker from './TimePicker';
import DomainPropTypes from '../constants/prop-types';
import BasePicker from '../_shared/BasePicker';

export const TimePickerInline = (props) => {
  const {
    value, format, onChange, ampm, forwardedRef, seconds, ...other
  } = props;

  return (
    <BasePicker {...props} autoOk>
      {
        ({
          date,
          utils,
          handleChange,
          handleTextFieldChange,
          isAccepted,
          pickFormat,
          handleAccept,
        }) => (
          <InlineWrapper
            innerRef={forwardedRef}
            value={value}
            onChange={handleTextFieldChange}
            isAccepted={isAccepted}
            handleAccept={handleAccept}
            format={pickFormat(utils.timeFormat)}
            {...other}
          >
            <TimePicker
              date={date}
              onChange={handleChange}
              ampm={ampm}
              seconds={seconds}
            />
          </InlineWrapper>
        )
      }
    </BasePicker>
  );
};

TimePickerInline.propTypes = {
  value: DomainPropTypes.date,
  format: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  ampm: PropTypes.bool,
  seconds: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

TimePickerInline.defaultProps = {
  ampm: true,
  value: new Date(),
  format: undefined,
  forwardedRef: undefined,
  seconds: false,
};

export default React.forwardRef((props, ref) => (
  <TimePickerInline {...props} forwardedRef={ref} />
));
